import LegalPageLayout from './LegalPageLayout';

export default function PolitiqueConfidentialite() {
  return <LegalPageLayout pageKey="privacy" />;
}
